import config from "../config/config";
import axios from "axios"
import { getToken } from "../Token";
import * as url from "../helpers/url_helper";
import { getTimezoneInfo } from '../helpers/timezone_helper';

const { timezoneName, formattedOffset } = getTimezoneInfo();

const token = getToken();
export const RoleModuleApi = {
    getAllModule: async () => {
        var axiosConfig = {
            method: 'get',
            url: `${config.API_URL}${url.FETCH_MENUS}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            //data: data
        };
        return await axios(axiosConfig);
    }
}